import { openDB } from 'idb';

const dbPromise = openDB('image-store', 1, {
  upgrade(db) {
    db.createObjectStore('images');
  },
});

export async function getImage(name) {
  return (await dbPromise).get('images', name);
}

export async function setImage(name, image) {
  return (await dbPromise).put('images', image, name);
}

export async function getAllImages() {
  return (await dbPromise).getAll('images');
}
